import {Companies as AllCompanies} from 'features/companies/';
import React from 'react';

function Companies() {
  return <AllCompanies />;
}

export default Companies;
